import { z } from "zod";

/** Mirrors backend/v2/platform/knowledge/tenant_knowledge.py */

export const MAX_BRIEF_LEN = 2000;
export const MAX_THEMES = 12;
export const MAX_THEME_LEN = 120;
export const MAX_VOCAB_ITEMS = 20;
export const MAX_VOCAB_ITEM_LEN = 40;

const vocabSchema = z.object({
  prefer: z.array(z.string().max(MAX_VOCAB_ITEM_LEN)).max(MAX_VOCAB_ITEMS).optional(),
  avoid: z.array(z.string().max(MAX_VOCAB_ITEM_LEN)).max(MAX_VOCAB_ITEMS).optional(),
});

export const workspaceKnowledgeSchema = z.object({
  customer_brief: z.string().max(MAX_BRIEF_LEN),
  strategic_themes: z.array(z.string().max(MAX_THEME_LEN)).max(MAX_THEMES),
  vocabulary: vocabSchema.optional(),
});

export function normalizeWorkspaceKnowledgePayload(form) {
  const parsed = workspaceKnowledgeSchema.safeParse(form);
  if (!parsed.success) {
    const flat = parsed.error.flatten().fieldErrors;
    const first = Object.values(flat).flat()[0];
    throw new Error(first || "Invalid workspace knowledge");
  }
  const v = parsed.data.vocabulary || {};
  return {
    customer_brief: (parsed.data.customer_brief || "").trim(),
    strategic_themes: (parsed.data.strategic_themes || [])
      .map((t) => t.trim())
      .filter(Boolean),
    vocabulary: {
      prefer: (v.prefer || []).map((x) => x.trim()).filter(Boolean),
      avoid: (v.avoid || []).map((x) => x.trim()).filter(Boolean),
    },
  };
}
